module.exports = __webpack_public_path__ + "img/card-green-tick.7497c3ce.svg";